import Reveal from "@/components/Reveal";
import content from "@/content/siteContent";

export default function Testimonial() {
  const t = content.testimonial;
  return (
    <section className="mx-auto max-w-7xl px-4 pb-24 sm:px-6 lg:px-8 lg:pb-32">
      <Reveal>
        <figure data-testid="testimonial-proballer" className="spotlight-frame relative overflow-hidden rounded-3xl bg-plz-surface/50 p-8 lg:p-14">
          <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-plz-orange/15 blur-3xl" aria-hidden="true" />
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-plz-orange">{t.label}</p>
          <blockquote className="mt-6 max-w-3xl font-heading text-xl font-semibold leading-relaxed sm:text-2xl lg:text-3xl">
            &ldquo;{t.quote}&rdquo;
          </blockquote>
          <figcaption className="mt-8 flex items-center gap-4">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-plz-orange font-heading text-lg font-extrabold text-plz-cream">
              {t.initials}
            </span>
            <div>
              <p className="font-heading text-base font-semibold">{t.author}</p>
              <p className="text-sm text-plz-muted">{t.role}</p>
            </div>
          </figcaption>
        </figure>
      </Reveal>
    </section>
  );
}
